import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.DeleteUiFile.IRequest;
type Response = Api.Core.DealerGroup.DeleteUiFile.IResponse;
type Headers = Api.Core.DealerGroup.DeleteUiFile.IHeaders;
const apiDealerGroupDeleteFilePath = '/api/DealerManagement/DealerGroup/:id/DeleteUiFile';
export default async function dealerGroupDeleteUiFileApi(id: number): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(apiDealerGroupDeleteFilePath, { id }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
